import { render, staticRenderFns } from "./ChzxBlock.vue?vue&type=template&id=53d4945a&scoped=true"
import script from "./ChzxBlock.vue?vue&type=script&lang=js"
export * from "./ChzxBlock.vue?vue&type=script&lang=js"
import style0 from "./ChzxBlock.vue?vue&type=style&index=0&id=53d4945a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d4945a",
  null
  
)

export default component.exports